
//         // src/pages/Dashboard/QuickQuote/components/SecondPage.jsx
// import React, { useState, useEffect } from 'react';
// import { quickQuoteApi } from '../../../../api/quickquote/quickQuoteApi';
// import styles from './SecondPage.module.css';

// const SecondPage = ({ initialData, headerValues, onBack, onViewSelected }) => {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [quantities, setQuantities] = useState({});

//   useEffect(() => {
//     fetchItems();
//   }, []);

//   const fetchItems = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       // Extract CAS numbers from initialData
//       const casNumbers = initialData.map(item => item.casNo);

//       console.log('🔍 Fetching items for CAS numbers:', casNumbers);

//       const data = await quickQuoteApi.getItemsByCasNumbers(casNumbers);

//       console.log('✅ Received items:', data);

//       // Match items with input data and calculate prices
//       const enrichedItems = data.map(item => {
//         // Find matching input row
//         const inputRow = initialData.find(
//           row => row.casNo.toUpperCase().trim() === item.cas.toUpperCase().trim()
//         );

//         if (!inputRow) return item;

//         // Calculate discount and final price
//         const discount = parseFloat(inputRow.discount) || 0;
//         const price = parseFloat(item.price) || 0;
//         const finalPrice = price - (price * discount / 100);

//         // Check if PKZ matches
//         const itemPKZ = `${item.quantity} ${item.uom}`.toUpperCase().trim();
//         const inputPKZ = (inputRow.packSize?.normalizedQuantity || '').toUpperCase().trim();
//         const packSizeMatches = itemPKZ === inputPKZ || 
//                                 item.quantity.toString().toUpperCase().trim() === inputPKZ;

//         return {
//           ...item,
//           discount: discount,
//           finalPrice: finalPrice,
//           refNo: inputRow.refNo || '',
//           packSize: inputRow.packSize || {},
//           packSizeMatches: packSizeMatches
//         };
//       });

//       setItems(enrichedItems);
//       setLoading(false);
//     } catch (err) {
//       console.error('❌ Error fetching items:', err);
//       setError(err.message || 'Failed to fetch items');
//       setLoading(false);
//     }
//   };

//   const handleQuantityChange = (slno, value) => {
//     const numValue = parseInt(value) || 0;
//     setQuantities(prev => ({
//       ...prev,
//       [slno]: numValue
//     }));
//   };

//   const handleViewSelected = () => {
//     // Get items with quantity >= 1
//     const selected = items.filter(item => (quantities[item.slno] || 0) >= 1);
    
//     if (selected.length === 0) {
//       alert('Please enter quantity for at least one item');
//       return;
//     }

//     // Calculate values for selected items
//     const enrichedSelected = selected.map(item => ({
//       ...item,
//       quantity: quantities[item.slno],
//       value: quantities[item.slno] * item.finalPrice
//     }));

//     onViewSelected(enrichedSelected, quantities);
//   };

//   // Calculate real-time statistics
//   const selectedCount = Object.values(quantities).filter(qty => qty >= 1).length;
//   const totalAmount = items.reduce((sum, item) => {
//     const qty = quantities[item.slno] || 0;
//     return sum + (qty * item.finalPrice);
//   }, 0);

//   if (loading) {
//     return (
//       <div className={styles.pageContainer}>
//         <div className={styles.card}>
//           <div className={styles.loadingContainer}>
//             <div className={styles.spinner}></div>
//             <p className={styles.loadingText}>Loading items...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className={styles.pageContainer}>
//         <div className={styles.card}>
//           <div className={styles.errorContainer}>
//             <p className={styles.errorText}>❌ {error}</p>
//             <button onClick={onBack} className={styles.backButton}>
//               ← Back to Input
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className={styles.pageContainer}>
//       <div className={styles.card}>
//         {/* Header */}
//         <div className={styles.header}>
//           <div>
//             <h2 className={styles.title}>Quick Quote Results</h2>
//             <p className={styles.subtitle}>
//               Enter quantities to select items for your quote
//               <span className={styles.matchInfo}>
//                 🟢 Green rows indicate PKZ matches
//               </span>
//             </p>
//           </div>
//           <div className={styles.headerButtons}>
//             <button onClick={onBack} className={styles.backButton}>
//               ← Back
//             </button>
//             <button 
//               onClick={handleViewSelected} 
//               className={styles.viewButton}
//               disabled={selectedCount === 0}
//             >
//               View Selected ({selectedCount})
//             </button>
//           </div>
//         </div>

//         <div className={styles.tableContainer}>
//           <div className={styles.tableWrapper}>
//             {/* Table Header */}
//             <div className={styles.scrollContainer}>
//               <table className={styles.table}>
//                 <thead className={styles.tableHeader}>
//                   <tr>
//                     <th className={styles.th}>S.No</th>
//                     <th className={styles.th}>CAS</th>
//                     <th className={styles.thWide}>Description</th>
//                     <th className={styles.th}>Cat_No</th>
//                     <th className={styles.th}>PKZ</th>
//                     <th className={styles.th}>UOM</th>
//                     <th className={styles.th}>Customer PKZ</th>
//                     <th className={styles.th}>Stock In India</th>
//                     <th className={styles.th}>China Stock</th>
//                     <th className={styles.th}>HAZ/Non HAZ</th>
//                     <th className={styles.th}>Price</th>
//                     <th className={styles.th}>Discount</th>
//                     <th className={styles.th}>Final Price</th>
//                     <th className={styles.th}>Reference</th>
//                     <th className={styles.th}>Qty</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {items.map((item) => (
//                     <tr 
//                       key={item.slno} 
//                       className={`${styles.tableRow} ${item.packSizeMatches ? styles.matchedRow : ''}`}
//                     >
//                       <td className={styles.td}>{item.slno}</td>
//                       <td className={styles.td}>{item.cas}</td>
//                       <td className={styles.tdWide}>{item.description}</td>
//                       <td className={styles.td}>{item.catNo}</td>
//                       <td className={styles.td}>{item.quantity}</td>
//                       <td className={styles.td}>{item.uom}</td>
//                       <td className={styles.td}>
//                         {item.packSize?.quantity ? (
//                           <span className={item.packSizeMatches ? styles.matchedText : ''}>
//                             {item.packSize.quantity}
//                             {item.packSizeMatches && <span className={styles.checkmark}> ✓</span>}
//                           </span>
//                         ) : (
//                           <span className={styles.emptyCell}>-</span>
//                         )}
//                       </td>
//                       <td className={styles.td}>{item.stockInIndia}</td>
//                       <td className={styles.td}>{item.chinaStock}</td>
//                       <td className={styles.td}>{item.hazStatus}</td>
//                       <td className={styles.tdRight}>₹{parseFloat(item.price).toFixed(2)}</td>
//                       <td className={styles.tdRight}>{item.discount}%</td>
//                       <td className={styles.tdRight}>₹{parseFloat(item.finalPrice).toFixed(2)}</td>
//                       <td className={styles.td}>{item.refNo}</td>
//                       <td className={styles.tdInput}>
//                         <input
//                           type="number"
//                           min="0"
//                           value={quantities[item.slno] || ''}
//                           onChange={(e) => handleQuantityChange(item.slno, e.target.value)}
//                           className={styles.qtyInput}
//                           placeholder="0"
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Footer */}
//             <div className={styles.footer}>
//               <div className={styles.footerStats}>
//                 Total Items: <span className={styles.statValue}>{items.length}</span> |
//                 Selected: <span className={styles.statValue}>{selectedCount}</span> |
//                 PKZ Matches: <span className={styles.matchValue}>
//                   {items.filter(item => item.packSizeMatches).length}
//                 </span> |
//                 Total Amount: <span className={styles.statValue}>₹{totalAmount.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SecondPage;


// src/pages/Dashboard/QuickQuote/components/SecondPage.jsx
import React, { useState, useEffect } from 'react';
import { quickQuoteApi } from '../../../../api/quickquote/quickQuoteApi';
import styles from './SecondPage.module.css';

const SecondPage = ({ initialData, headerValues, onBack, onViewSelected }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantities, setQuantities] = useState({});

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      setLoading(true);
      setError(null);

      // Extract CAS numbers from initialData
      const casNumbers = initialData.map(item => item.casNo);

      console.log('🔍 Fetching items for CAS numbers:', casNumbers);

      const data = await quickQuoteApi.getItemsByCasNumbers(casNumbers);

      console.log('✅ Received items:', data);

      // Match items with input data and calculate prices
      const enrichedItems = data.map(item => {
        // Find matching input row
        const inputRow = initialData.find(
          row => row.casNo.toUpperCase().trim() === item.cas.toUpperCase().trim()
        );

        if (!inputRow) return item;

        // Calculate discount and final price
        const discount = parseFloat(inputRow.discount) || 0;
        const price = parseFloat(item.price) || 0;
        const finalPrice = price - (price * discount / 100);

        // Normalize quantities for comparison (remove trailing zeros, ignore case)
        const normalizeValue = (val) => {
          if (!val) return '';
          // Convert to string, remove trailing zeros after decimal, uppercase
          const strVal = val.toString().toUpperCase().trim();
          const numVal = parseFloat(strVal);
          return isNaN(numVal) ? strVal : numVal.toString().toUpperCase();
        };

        // Check if PKZ matches with normalized comparison
        const itemPKZ = normalizeValue(`${item.quantity}${item.uom}`);
        const inputPKZ = normalizeValue(inputRow.packSize?.normalizedQuantity || inputRow.packSize?.quantity || '');
        
        // Also try matching just the quantity part
        const itemQty = normalizeValue(item.quantity);
        const inputQty = normalizeValue(inputRow.packSize?.quantity || '');
        
        const packSizeMatches = itemPKZ === inputPKZ || itemQty === inputQty;

        return {
          ...item,
          discount: discount,
          finalPrice: finalPrice,
          refNo: inputRow.refNo || '',
          packSize: inputRow.packSize || {},
          packSizeMatches: packSizeMatches
        };
      });

      // Sort by final price (lowest to highest)
      enrichedItems.sort((a, b) => a.finalPrice - b.finalPrice);

      setItems(enrichedItems);
      setLoading(false);
    } catch (err) {
      console.error('❌ Error fetching items:', err);
      setError(err.message || 'Failed to fetch items');
      setLoading(false);
    }
  };

  const handleQuantityChange = (slno, value) => {
    const numValue = parseInt(value) || 0;
    setQuantities(prev => ({
      ...prev,
      [slno]: numValue
    }));
  };

  const handleViewSelected = () => {
    // Get items with quantity >= 1
    const selected = items.filter(item => (quantities[item.slno] || 0) >= 1);
    
    if (selected.length === 0) {
      alert('Please enter quantity for at least one item');
      return;
    }

    // Calculate values for selected items
    const enrichedSelected = selected.map(item => ({
      ...item,
      quantity: quantities[item.slno],
      value: quantities[item.slno] * item.finalPrice
    }));

    onViewSelected(enrichedSelected, quantities);
  };

  // Calculate real-time statistics
  const selectedCount = Object.values(quantities).filter(qty => qty >= 1).length;
  const totalAmount = items.reduce((sum, item) => {
    const qty = quantities[item.slno] || 0;
    return sum + (qty * item.finalPrice);
  }, 0);

  if (loading) {
    return (
      <div className={styles.pageContainer}>
        <div className={styles.card}>
          <div className={styles.loadingContainer}>
            <div className={styles.spinner}></div>
            <p className={styles.loadingText}>Loading items...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.pageContainer}>
        <div className={styles.card}>
          <div className={styles.errorContainer}>
            <p className={styles.errorText}>❌ {error}</p>
            <button onClick={onBack} className={styles.backButton}>
              ← Back to Input
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.card}>
        {/* Header */}
        <div className={styles.header}>
          <div>
            <h2 className={styles.title}>Quick Quote Results</h2>
            <p className={styles.subtitle}>
              Enter quantities to select items for your quote
              <span className={styles.matchInfo}>
                🟢 Green rows indicate PKZ matches
              </span>
            </p>
          </div>
          <div className={styles.headerButtons}>
            <button onClick={onBack} className={styles.backButton}>
              ← Back
            </button>
            <button 
              onClick={handleViewSelected} 
              className={styles.viewButton}
              disabled={selectedCount === 0}
            >
              View Selected ({selectedCount})
            </button>
          </div>
        </div>

        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            {/* Table Header */}
            <div className={styles.scrollContainer}>
              <table className={styles.table}>
                <thead className={styles.tableHeader}>
                  <tr>
                    <th className={styles.th}>S.No</th>
                    <th className={styles.th}>CAS</th>
                    <th className={styles.thWide}>Description</th>
                    <th className={styles.th}>Cat_No</th>
                    <th className={styles.th}>PKZ</th>
                    <th className={styles.th}>UOM</th>
                    <th className={styles.th}>Customer PKZ</th>
                    <th className={styles.th}>Stock In India</th>
                    <th className={styles.th}>China Stock</th>
                    <th className={styles.th}>HAZ/Non HAZ</th>
                    <th className={styles.th}>Price</th>
                    <th className={styles.th}>Discount</th>
                    <th className={styles.th}>Final Price</th>
                    <th className={styles.th}>Reference</th>
                    <th className={styles.th}>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr 
                      key={item.slno} 
                      className={`${styles.tableRow} ${item.packSizeMatches ? styles.matchedRow : ''}`}
                    >
                      <td className={styles.td}>{index + 1}</td>
                      <td className={styles.td}>{item.cas}</td>
                      <td className={styles.tdWide}>{item.description}</td>
                      <td className={styles.td}>{item.catNo}</td>
                      <td className={styles.td}>{item.quantity}</td>
                      <td className={styles.td}>{item.uom}</td>
                      <td className={styles.td}>
                        {item.packSize?.quantity ? (
                          <span className={item.packSizeMatches ? styles.matchedText : ''}>
                            {item.packSize.quantity}
                            {item.packSizeMatches && <span className={styles.checkmark}> ✓</span>}
                          </span>
                        ) : (
                          <span className={styles.emptyCell}>-</span>
                        )}
                      </td>
                      <td className={styles.td}>{item.stockInIndia}</td>
                      <td className={styles.td}>{item.chinaStock}</td>
                      <td className={styles.td}>{item.hazStatus}</td>
                      <td className={styles.tdRight}>₹{parseFloat(item.price).toFixed(2)}</td>
                      <td className={styles.tdRight}>{item.discount}%</td>
                      <td className={styles.tdRight}>₹{parseFloat(item.finalPrice).toFixed(2)}</td>
                      <td className={styles.td}>{item.refNo}</td>
                      <td className={styles.tdInput}>
                        <input
                          type="number"
                          min="0"
                          value={quantities[item.slno] || ''}
                          onChange={(e) => handleQuantityChange(item.slno, e.target.value)}
                          className={styles.qtyInput}
                          placeholder="0"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
              <div className={styles.footerStats}>
                Total Items: <span className={styles.statValue}>{items.length}</span> |
                Selected: <span className={styles.statValue}>{selectedCount}</span> |
                PKZ Matches: <span className={styles.matchValue}>
                  {items.filter(item => item.packSizeMatches).length}
                </span> |
                Total Amount: <span className={styles.statValue}>₹{totalAmount.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondPage;